import { Component, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-pedido-cancelado',
    standalone: false,
    templateUrl: './pedido-cancelado.component.html',
    styleUrl: './pedido-cancelado.component.scss'
})
export class PedidoCanceladoComponent
{
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    fazerNovoPedido()
    {
        this.router.navigate(['../novo'], { relativeTo: this.route });
    }

    voltarPaginaInicial()
    {
        this.router.navigate(['../../'], { relativeTo: this.route });
    }
}
